import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { DashboardPreview } from './DashboardPreview';
import { Button } from './ui/Button';
import { Header } from './Header';
import { MarketChallenges } from './MarketChallenges';
import { TradeInSolutions } from './TradeInSolutions';
import { AdvancedFeatures } from './AdvancedFeatures';
import { AIAssessment } from './AIAssessment';
import { AIGradingProcess } from './AIGradingProcess';
import { DiagnosticPlatform } from './DiagnosticPlatform';
import { TradeInWidget } from './TradeInWidget';
import { DashboardPreviewTabs } from './DashboardPreviewTabs';
import { SyndicateAuctions } from './SyndicateAuctions';
import { useTranslation } from 'react-i18next';
import { Logo } from './Logo';
import { AIAndDiagnosticsSection } from './AIAndDiagnosticsSection';
import { TestimonialsSection } from './TestimonialsSection';
import { ClosingCTA } from './ClosingCTA';
import { DeviceMetrics } from './DeviceMetrics';
export function LandingPage() {
  const {
    t
  } = useTranslation();
  return <div className="w-full min-h-screen bg-adaptive" data-id="element-678">
      <Header data-id="element-679" />
      <div className="relative pt-32 pb-28 sm:pt-40 sm:pb-36 overflow-hidden min-h-[95vh] flex items-center" data-id="element-680">
        <div className="absolute w-full h-full inset-0 bg-gradient-to-br from-blue-50 to-emerald-50 dark:from-gray-900 dark:to-black opacity-70" data-id="element-681"></div>
        <div className="absolute w-[600px] h-[600px] rounded-full bg-blue-200 dark:bg-blue-900/20 opacity-20 blur-3xl -top-64 -left-64" data-id="element-682"></div>
        <div className="absolute w-[600px] h-[600px] rounded-full bg-emerald-200 dark:bg-brand-green/5 opacity-20 blur-3xl -bottom-64 -right-64" data-id="element-683"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-684">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8 items-center" data-id="element-685">
            <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-5 lg:text-left lg:flex lg:flex-col lg:justify-center" data-id="element-686">
              <div data-id="element-687">
                <div className="inline-flex items-center px-4 py-1 rounded-full text-sm font-medium bg-blue-50 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green mb-4" data-id="element-688">
                  {t('hero.badge')}
                </div>
                <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl" data-id="element-689">
                  <span className="block" data-id="element-690">{t('hero.title.line1')}</span>
                  <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500 dark:from-brand-green dark:to-brand-green/60" data-id="element-691">
                    {t('hero.title.line2')}
                  </span>
                </h1>
                <div className="mt-6 text-xl space-y-4" data-id="element-692">
                  <p className="font-bold text-2xl text-gray-900 dark:text-white" data-id="element-693">
                    {t('hero.subtitle.heading')}
                  </p>
                  <p className="text-gray-500 dark:text-gray-400" data-id="element-694">
                    {t('hero.subtitle.description')}
                  </p>
                </div>
                <div className="mt-10 sm:flex sm:justify-center lg:justify-start" data-id="element-695">
                  <div className="rounded-full shadow" data-id="element-696">
                    <Button className="px-8 py-3 rounded-full md:py-4 md:text-lg md:px-10 bg-blue-600 dark:bg-brand-green text-white dark:text-black hover:bg-blue-700 dark:hover:bg-brand-green/90" data-id="element-697">
                      {t('hero.buttons.demo')}
                    </Button>
                  </div>
                  <div className="mt-3 sm:mt-0 sm:ml-3" data-id="element-698">
                    <Button variant="outline" className="px-8 py-3 rounded-full border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 bg-white dark:bg-black hover:bg-gray-50 dark:hover:bg-gray-900 md:py-4 md:text-lg md:px-10 group" data-id="element-699">
                      {t('hero.buttons.learn')}
                      <ChevronRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-700" />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-12 lg:mt-0 lg:col-span-7 lg:flex lg:items-center" data-id="element-701">
              <div className="relative w-full flex items-center justify-end" data-id="element-702">
                <div className="absolute right-0 transform translate-x-1/4 w-[130%] max-w-[1000px] top-1/2 -translate-y-1/2" data-id="element-703">
                  <div className="relative" data-id="element-704">
                    <div className="relative bg-gray-800 rounded-xl pt-5 pb-6 shadow-2xl" data-id="element-705">
                      <div className="absolute top-0 left-0 right-0 h-5 bg-gray-800 rounded-t-xl flex items-center px-4" data-id="element-706">
                        <div className="flex space-x-2" data-id="element-707">
                          <div className="w-2.5 h-2.5 rounded-full bg-red-500" data-id="element-708"></div>
                          <div className="w-2.5 h-2.5 rounded-full bg-yellow-500" data-id="element-709"></div>
                          <div className="w-2.5 h-2.5 rounded-full bg-green-500" data-id="element-710"></div>
                        </div>
                      </div>
                      <div className="rounded-lg overflow-hidden" data-id="element-711">
                        <DashboardPreview data-id="element-712" />
                      </div>
                    </div>
                    <div className="absolute -bottom-6 left-[5%] right-[5%] h-10 bg-black/20 blur-xl rounded-full z-[-1]" data-id="element-713"></div>
                  </div>
                </div>
                <div className="w-full aspect-[16/8] lg:aspect-[16/8] opacity-0" data-id="element-714"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MarketChallenges data-id="element-715" />
      <TradeInSolutions data-id="element-716" />
      <AIGradingProcess data-id="element-717" />
      <AdvancedFeatures data-id="element-718" />
      <AIAndDiagnosticsSection data-id="element-719" />
      <TradeInWidget data-id="element-720" />
      <DiagnosticPlatform id="demo" data-id="element-721" />
      <DashboardPreviewTabs data-id="element-722" />
      <SyndicateAuctions id="auctions" data-id="element-723" />
      <DeviceMetrics data-id="element-724" />
      <TestimonialsSection data-id="element-725" />
      <ClosingCTA data-id="element-726" />
      <footer className="bg-gray-50 dark:bg-black text-gray-800 dark:text-white py-12 border-t border-gray-200 dark:border-gray-800" data-id="element-727">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-728">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-729">
            <div data-id="element-730">
              <Logo variant="stacked" data-id="element-731" />
              <p className="text-gray-600 dark:text-gray-400 text-sm mt-4" data-id="element-732">
                The future of trade-in wholesale technology. Empowering
                businesses with AI-driven market insights.
              </p>
            </div>
            <div data-id="element-733">
              <h3 className="font-medium mb-4 text-gray-900 dark:text-white" data-id="element-734">
                Solutions
              </h3>
              <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400" data-id="element-735">
                <li data-id="element-736">
                  <a href="#consumer-trade-in" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-737">
                    Consumer Trade-In
                  </a>
                </li>
                <li data-id="element-738">
                  <a href="#business-platform" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-739">
                    Business Platform
                  </a>
                </li>
                <li data-id="element-740">
                  <a href="#wholesale-marketplace" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-741">
                    Wholesale Marketplace
                  </a>
                </li>
                <li data-id="element-742">
                  <a href="#auctions" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-743">
                    Auction Platform
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-744">
              <h3 className="font-medium mb-4 text-gray-900 dark:text-white" data-id="element-745">
                Company
              </h3>
              <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400" data-id="element-746">
                <li data-id="element-747">
                  <a href="#about" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-748">
                    About Us
                  </a>
                </li>
                <li data-id="element-749">
                  <a href="#careers" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-750">
                    Careers
                  </a>
                </li>
                <li data-id="element-751">
                  <a href="#press" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-752">
                    Press
                  </a>
                </li>
                <li data-id="element-753">
                  <a href="#contact" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-754">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-755">
              <h3 className="font-medium mb-4 text-gray-900 dark:text-white" data-id="element-756">
                Legal
              </h3>
              <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400" data-id="element-757">
                <li data-id="element-758">
                  <a href="#privacy" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-759">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-760">
                  <a href="#terms" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-761">
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-762">
                  <a href="#cookies" className="hover:text-blue-600 dark:hover:text-brand-green" data-id="element-763">
                    Cookie Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200 dark:border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-764">
            <div className="text-gray-600 dark:text-gray-400 text-sm" data-id="element-765">
              © 2024 R3UP. All rights reserved.
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-766">
              <a href="#" className="text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-brand-green" data-id="element-767">
                <span className="sr-only" data-id="element-768">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-769">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-770" />
                </svg>
              </a>
              <a href="#" className="text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-brand-green" data-id="element-771">
                <span className="sr-only" data-id="element-772">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-773">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-774" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}